module.exports = __webpack_public_path__ + "img/Contacts (1).f0b9a3a.png";